// extracted by mini-css-extract-plugin
module.exports = {"container":"subscription_container__dHlvK","subscribe":"subscription_subscribe__1vVbs"};